export enum EventTypes {
    SVT = 'svt',
    ACN = 'acn',
    MCALL = 'mcall',
    MCALL_COUNT = 'mcall-count',
    ACN_COUNT = 'acn-count',
    SECURITYALRAM = 'security-alert',
    WLAMP = 'warning-lamp',
    CALL_ME = 'call-me',
    SEARCHRESULTS = 'search-results'
}
